<template>
  <t-dialog
      v-model:visible="visible"
      header="新增客户"
      width="520px"
      :confirm-btn="{ content: '保存', theme: 'primary' }"
      :cancel-btn="{ content: '关闭' }"
      @confirm="handleSubmit"
  >
    <t-form
        ref="formRef"
        :data="formData"
        :rules="rules"
        label-width="90px"
    >

      <t-form-item label="手机号" name="mobile">
        <t-input
            v-model="formData.mobile"
            placeholder="请输入手机号"
        />
      </t-form-item>

      <t-form-item label="公司名称" name="company">
        <t-input
            v-model="formData.company"
            placeholder="请输入公司名称"
        />
      </t-form-item>

      <t-form-item label="店长名称" name="manager">
        <t-input
            v-model="formData.manager"
            placeholder="请输入店长名称"
        />
      </t-form-item>

      <t-form-item label="系统版本" name="level">
        <t-select v-model="formData.level">
          <t-option label="标准版" value="Standard" />
          <t-option label="入门版" value="Basic" />
        </t-select>
      </t-form-item>

      <t-form-item label="使用时间" name="level_time">
        <t-select v-model="formData.level_time">
          <t-option label="一个月" value="oneMonth" />
          <t-option label="三个月" value="threeMonth" />
          <t-option label="半年" value="sixMonth" />
          <t-option label="一年" value="oneYear" />
        </t-select>
      </t-form-item>

      <t-form-item label="来源" name="source">
        <t-select v-model="formData.source">
          <t-option label="获客系统" value="huoke" />
          <t-option label="其他来源" value="other" />
        </t-select>
      </t-form-item>

    </t-form>
  </t-dialog>
</template>

<script setup>
import { ref, watch } from "vue"

const props = defineProps({
  visible: Boolean
})

const emit = defineEmits(["update:visible", "success"])

const visible = ref(false)

watch(
    () => props.visible,
    (v) => {
      visible.value = v
    }
)

watch(visible, (v) => {
  emit("update:visible", v)
})

const formRef = ref()

const formData = ref({
  mobile: "",
  company: "",
  manager: "",
  source: "huoke",
  level: "Standard",
  level_time: ''
})

const rules = {
  mobile: [
    { required: true, message: "请输入手机号" }
  ],
}

/** 提交 */
const handleSubmit = async () => {

  const valid = await formRef.value.validate()

  if (!valid) return

  const params = {
    ...formData.value
  }

  console.log("提交数据", params)

  /** 这里调用后端接口 */
  // await apiCreateCustomer(params)

  /** 成功后关闭 */
  visible.value = false

  emit("success")
}
</script>